import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import mkd from "./locales/mkd.json";
import al from "./locales/al.json";
import tr from "./locales/tr.json";
import es from "./locales/es.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: en,
      },
      mkd: {
        translation: mkd,
      },
      tr: {
        translation: tr,
      },
      al: {
        translation: al,
      },
      es: {
        translation: es,
      },
    },
    fallbackLng: "en",
    lng: "en",
    debug: process.env.NODE_ENV === "development",
    interpolation: {
      escapeValue: false,
    },
    returnObjects: true,
  });

export default i18n;
